export default {
    routerName: '文章管理',
    article: {
        title: 'タイトル',
        author: '作者',
        releaseTime: 'リリース日付',
        createStartTime: 'リリース開始',
        createEndTime: 'リリース終了',
        category: 'カテゴリー',
        hot: 'ホットニュース',
        recommend: 'おすすめ記事',
        recommendTop: '推薦TOP',
        topic: 'トピック',
        disabled: '無効',
        yes: 'はい',
        no: 'いいえ',
        slider: 'スライド',
        status: '状態',
        statusOption0: '下書き',
        statusOption1: '審査失敗',
        statusOption2: '審査中',
        statusOption9: '審査成功',
        charge: '有无料',
        charge0: '有料',
        charge1: '无料',
        hits: '閲覧量',
        defaultImg: 'デフォルト画像',
        body: '詳細',
    },
    table: {
        id: 'ID',
        title: 'タイトル',
        author: '作者',
        status: '状態',
        category: 'カテゴリー',
        hot: 'ホ',
        recommend: '記',
        recommendTop: '薦T',
        topic: 'ト',
        slider: 'ス',
        disabled: '無効',
        createBy: '作成者',
        releaseTime: 'リリース日付',
        charge: '有无料',
        charge0: '有料',
        charge1: '无料',
        hits: '閲覧量',
        defaultImg: 'デフォルト画像',
    },
    message: {
        delConfirmTitle: '削除警告',
        delIncludeSubNodeConfirm: 'すべての子ノードを削除しますか？',
        delConfirm: 'データを削除してもよろしいですか？',
    },
};
